export default __webpack_public_path__ + "static/media/FINAL_WorkForce_Logo-.f2c5f49f.jpg";